<template>
  <div data-app>
    <el-dialog
      class="dialogWallet"
      :show-close="false"
      center
      :visible.sync="$store.getters.isShowWallet"
      :before-close="handleClose"
      :height="dialogMinHeight"
      :bottom="0"
    >
      <div class="wallet-container mb-20">
        <div style="margin-top: 40px;" class="text-center">
          <img :src="icons.WalletIcon" alt="" />
          <div class="mt-20">
            <p style="color: black;" class="fw-500 m-0">
              {{ $t("wap.text51") }}
            </p>
            <p style="color: black;" class="fw-600 mt-10 c-h3">
              {{ formatNumber($store.getters.point) }}
              <span
                style="position: absolute; padding-left:5px"
                class="c-title2"
                >đ</span
              >
            </p>
          </div>
        </div>
        <div
          style="background: #fff; margin-top:30px; padding-top:1px; padding-bottom:1px"
          class="border-radius-10 cursor-pointer"
        >
          <div
            v-if="!getToken().bank_id"
            @click="ShowAddPoint"
            class="mt-10 mb-10 px-15"
          >
            <img class="mr-20" :src="icons.AddWalletIcon" alt="" />
            <span class="c-caption fw-500">{{ $t("wap.text52") }}</span>
          </div>
          <div v-if="!getToken().bank_id" class="hr-menu"></div>

          <div @click="showHistoryTransactionWallet" class="mt-10 mb-10 px-15">
            <img class="mr-20" :src="icons.TimeIcon" alt="" />
            <span class="c-caption fw-500">{{ $t("wap.text53") }}</span>
          </div>
          <div class="hr-menu"></div>

          <div @click="ShowConditionWallet" class="mt-10 mb-10 px-15">
            <img class="mr-20" :src="icons.DotBarIcon" alt="" />
            <span class="c-caption fw-500">{{ $t("wap.text54") }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBackGround, getToken } from "@/utils/wapAuth";
import WalletIcon from "@/assets/img/iconV2/icon_wallet.svg";
import DotBarIcon from "@/assets/img/iconV2/dotBar.svg";
import AddWalletIcon from "@/assets/img/iconV2/add_wallet.svg";
import TimeIcon from "@/assets/img/iconV2/time.svg";
import { formatNumber } from "@/plugins/init";

export default {
  name: "dialogWallet",
  props: {},

  data() {
    return {
      bg: getBackGround(),
      isMobile: true,
      icons: {
        WalletIcon,
        DotBarIcon,
        AddWalletIcon,
        TimeIcon
      }
    };
  },
  computed: {
    dialogMinHeight() {
      return window.innerHeight * 0.9 + "px";
    }
  },
  watch: {},
  methods: {
    formatNumber,
    getToken,
    ShowConditionWallet() {
      window.open("https://wghn.net/terms-of-service-vwallet", "_blank");
    },
    handleClose() {
      this.$store.dispatch("setShowWallet", false);
    },
    hideDialog() {
      this.$store.dispatch("setShowWallet", false);
      this.$store.dispatch("setShowProfile", false);
    },
    showHistoryTransactionWallet() {
      this.hideDialog();
      this.$router.push({ name: "wallet-history-transaction" });
    },
    ShowAddPoint() {
      this.hideDialog();
      this.$router.push({ name: "wallet-add-point" });
    }
  }
};
</script>
<style lang="scss">
$color_slider: v-bind("bg.c_button_main");
// $color_radio_check: v-bind("bg.c_inherit_text");
$color_radio_check: v-bind("bg.c_button_main");
$color_slider_bar: #d9d9d9;

.mt-15 {
  margin-top: 15px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.dialogWallet .el-dialog {
  position: relative;
  border-radius: 10px;
  background: rgba(240, 241, 245, 1);
  min-height: 10vh;
  max-height: 380px;
  overflow: hidden;
  max-width: 500px !important;
  width: 100%;
  z-index: 2100;

  min-width: 350px !important;
  margin-bottom: 0 !important;
  margin-top: 10vh !important;

  .el-dialog__body {
    padding-top: 0 !important;
    padding-bottom: 30px !important;
  }

  .el-dialog__header {
    margin: 0;
    padding: 0;
  }
  .el-slider {
    height: 25px !important;
    .el-slider__bar {
      height: 3px !important;
      background-color: $color_slider;
    }
    .el-slider__runway {
      background-color: $color_slider_bar;
      height: 3px !important;
    }
  }
  .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: none !important;
    position: relative;
    top: -1px;
    background-color: $color_slider !important;
  }
  .service-radio {
    .el-radio {
      margin: 10px 0;
    }
  }
  .el-radio__inner {
    border: 1.5px solid #3c3c434d !important;
    width: 20px !important;
    height: 20px !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: $color_radio_check !important;
    border-color: $color_radio_check !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: inherit !important;
  }
}
.el-tooltip__popper {
  display: none !important;
}
.radio .el-radio__label {
  padding-left: 5px;
}
.radio .el-radio {
  margin-right: 10px;
}
@media screen and (min-width: 0px) and (max-width: 600px) {
  .dialogWallet .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 20vh !important;
    border-radius: 10px;
    background: rgba(240, 241, 245, 1);
    min-height: 10vh;
    max-height: 380px;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    z-index: 2100;
    min-width: 350px !important;
    margin-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 380px) {
  .dialogWallet .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 10vh !important;
    border-radius: 10px;
    background: rgba(240, 241, 245, 1);
    min-height: 10vh;
    max-height: 380px;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    min-width: 350px !important;
    margin-bottom: 0 !important;
    z-index: 2100;

    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (max-width: 320px) and (max-height: 568px) {
  .dialogWallet .el-dialog {
    margin-top: 10vh !important; /* Giảm khoảng cách từ trên xuống */
    min-height: 10vh;
    bottom: 0;
    min-height: auto; /* Bỏ giá trị cố định cho chiều cao tối thiểu */
    max-height: none; /* Bỏ giới hạn chiều cao tối đa */
    max-width: 100% !important; /* Đặt chiều rộng tối đa là 100% */
    min-width: 90% !important; /* Đặt chiều rộng tối thiểu là 90% */
    border-radius: 0; /* Loại bỏ viền bo tròn */
    z-index: 2100;
  }
}
</style>

<style lang="scss" scoped>
$divider-color: #ececec;

$color-btn: v-bind("bg.c_button_main");
.hr-menu {
  background-color: rgba(230, 232, 239, 1);
  height: 1px;
  width: 100%;
}
.divider-view {
  height: 2px;
  width: 100%;
  margin: 5px 0;
  background-color: $divider-color;
}
.btn_submit {
  border-radius: 8px;
  height: 40px;
  position: absolute;
  z-index: 1000;
  bottom: 20px;
  background-color: $color-btn !important;
}
.w-100 {
  width: 100%;
}
.mr-10 {
  margin-right: 10px;
}
</style>
